// extracted by mini-css-extract-plugin
export default {"signature":"SidebarSignature_signature__L1HsH","name":"SidebarSignature_name__--STG","year":"SidebarSignature_year__HN5UQ"};